module.exports = __webpack_public_path__ + "img/education-menu-cafeteria.fc300002.webp";